import {HostBinding, Input, OnInit} from '@angular/core';

export class GridContainerClass implements OnInit {
    /**
     * "Плоский" элемент не будет иметь отступы
     * @type {boolean}
     */
    @HostBinding('class._flat') @Input() public flat = false;
    /**
     * Как располагать элементы в FlexBox контейнере
     * @type {string}
     */
    @HostBinding('style.align-items') @Input() public align = 'flex-start';
    @HostBinding('style.justify-items') @Input() public justify = 'flex-start';
    @HostBinding('style.width') @Input() public width: number | string;

    @HostBinding('style.paddingLeft') private _paddingLeft = null;
    @HostBinding('style.paddingRight') private _paddingRight = null;

    @Input() public padding: number;
    @Input() public paddingRight: number;
    @Input() public paddingLeft: number;

    ngOnInit() {
        if (this.paddingRight !== undefined) {
            this._paddingRight = `${this.paddingRight}px`;
        }


        if (this.paddingLeft !== undefined) {
            this._paddingLeft = `${this.paddingLeft}px`;
        }

        if (this.padding !== undefined) {
            this._paddingLeft = `${this.padding}px`;
            this._paddingRight = `${this.padding}px`;
        }
    }
}

